// Selectors
import { getCurrentUserRootBoardId } from '../../user/currentUserSelector';
import { fullVirtualBoardParentGraphSelector } from '../../element/selectors/elementGraphSelector';
import { getCurrentBoardId } from '../../reducers/currentBoardId/currentBoardIdSelector';
import { getSelectedElements } from '../../element/selection/selectedElementsSelector';
import { activePopupSelector } from '../../components/popupPanel/popupOpenSelector';
import { activeModalIdSelector } from '../../components/modal/activeModalSelector';
import { breadcrumbSelector } from '../breadcrumbs/breadcrumbSelector';
import { getPreviousViewedBoardId } from '../../user/navigationHistory/navigationHistorySelector';

// Actions
import { getElementId, getElementType } from '../../../common/elements/utils/elementPropertyUtils';
import { navigateToBoard, navigateToCurrentBoard, navigateToElement } from '../../reducers/navigationActions';
import { isEmpty } from '../../../common/utils/immutableHelper';

// Constants
import { ELEMENT_MODAL_SUB_PATH } from '../../../common/utils/urlConstants';
import { ElementType } from '../../../common/elements/elementTypes';

/**
 * Navigates to the parent board.
 */
export const dispatchNavigateUpHierarchy = (event) => (dispatch, getState) => {
    event.preventDefault();
    event.stopPropagation();

    const state = getState();
    const rootBoardId = getCurrentUserRootBoardId(state);

    const breadcrumb = breadcrumbSelector(state);
    const { path = [] } = breadcrumb;

    // Detached boards will navigate to the root board if the user is logged in
    if (breadcrumb.detached && path.length <= 1) {
        return rootBoardId ? dispatch(navigateToBoard({ boardId: rootBoardId })) : null;
    }

    // Otherwise if we're on the root board, do nothing
    if (path.length <= 1) return;

    // Finally, navigate to the second last entry in the path
    const targetId = path[path.length - 2];
    dispatch(navigateToBoard({ boardId: targetId }));
};

/**
 * Navigates back to the child board.
 */
export const dispatchNavigateDownHierarchy = () => (dispatch, getState) => {
    const state = getState();
    const currentBoardId = getCurrentBoardId(state);
    const previouslyViewedBoardId = getPreviousViewedBoardId(state);

    if (!previouslyViewedBoardId) return;

    // If the current board is a parent of the previous board, we can "navigate down" to it.
    const parentGraph = fullVirtualBoardParentGraphSelector(state);
    const previousBoardParentIds = parentGraph[previouslyViewedBoardId];

    if (previousBoardParentIds && previousBoardParentIds.indexOf(currentBoardId) !== -1) {
        dispatch(navigateToBoard({ boardId: previouslyViewedBoardId }));
    }
};

const handleNavigation = (element) => (dispatch, getState) => {
    const elementId = getElementId(element);
    const elementType = getElementType(element);

    switch (elementType) {
        // Images should open their modal
        case ElementType.BOARD_TYPE:
            return dispatch(navigateToBoard({ boardId: elementId }));
        case ElementType.DOCUMENT_TYPE:
        case ElementType.SKETCH_TYPE:
        case ElementType.IMAGE_TYPE:
            return dispatch(navigateToElement({ elementId }));
        default:
            return null;
    }
};

export const handleSpaceShortcutAction = () => (dispatch, getState) => {
    const state = getState();

    const activePopups = activePopupSelector(state);
    if (!isEmpty(activePopups)) return;

    const activeModalId = activeModalIdSelector(state);

    // If the element modal is open, close it
    if (activeModalId && activeModalId.startsWith(`/${ELEMENT_MODAL_SUB_PATH}/`)) {
        return dispatch(navigateToCurrentBoard());
    }

    if (activeModalId) return;

    const selectedElements = getSelectedElements(state);
    if (selectedElements.size !== 1) return;

    const selectedElement = selectedElements.first();
    return dispatch(handleNavigation(selectedElement));
};
